// SCR-15 cost policy (plan 8.4.15, 6.2.7 price_tables, 10.1.2): price versions (never edited, a new version is added
// from a future date), cost-kind explanations (numbers come from the stats api-costs card). Budgets are P6 (excluded).
import { z } from 'zod';
import { Provider } from '../enums.js';
import { Count, Ymd } from '../common.js';

/** Price per million tokens in integer micro-dollars ($3.00 / MTok = 3_000_000). */
const MicrosPerMTok = z.int().min(0).max(1_000_000_000);
export const PriceRow = z.object({
  model: z.string().min(1).max(80),
  provider: Provider,
  /** Glob-like pattern the gateway matches (`claude-sonnet-4-5*`). */
  modelPattern: z.string().min(1).max(120),
  input: MicrosPerMTok,
  output: MicrosPerMTok,
  cacheRead: MicrosPerMTok,
  /** null where the provider has no cache-write price (OpenAI). */
  cacheWrite5m: MicrosPerMTok.nullable(),
  cacheWrite1h: MicrosPerMTok.nullable(),
  /** Long-context surcharge tier, if any. */
  longContext: z.object({ thresholdTokens: Count, input: MicrosPerMTok, output: MicrosPerMTok }).nullable(),
});
export type PriceRow = z.infer<typeof PriceRow>;

export const PriceVersion = z.object({
  version: z.string(),
  /** Date the administrator verified this price version against the supplier. */
  confirmedAt: Ymd,
  effectiveFrom: Ymd,
  /** The day before the next version starts (null = open). */
  effectiveTo: Ymd.nullable(),
  status: z.enum(['current', 'scheduled', 'past']),
  rows: z.array(PriceRow),
  changedCells: Count.nullable(),
});
export const PriceTablesResponse = z.object({ versions: z.array(PriceVersion), models: z.array(z.object({ id: z.string(), label: z.string(), provider: Provider })) });
/** POST /api/v1/admin/cost/price-tables — effectiveFrom ≥ tomorrow and unique (409 otherwise); past costs keep their version. */
export const PriceVersionCreateRequest = z.object({ effectiveFrom: Ymd, confirmedAt: Ymd, rows: z.array(PriceRow).min(1).max(200) });
export const PriceVersionCreateResponse = PriceVersion;

export const adminCostSchemas = { PriceTablesResponse, PriceVersionCreateRequest, PriceVersionCreateResponse, PriceVersion } as const;
